// Tina authenticates IMS by the signed-in curator's Firebase ID token.
//
// IMS used to send a static bearer from `VITE_TINA_ORCHESTRATOR_API_KEY`, but
// Vite compiles every `VITE_*` value into the public JS bundle, so anyone who
// loaded the login page held the key to every Tina route. The orchestrator now
// verifies the ID token itself and applies the Admin API's own rule: project
// `wheretogo-e5f51` plus the `admin` custom claim — the same claim the login
// gate in `auth-provider.tsx` checks. See tina src/orchestrator/deps/firebase_auth.py.
//
// `getIdToken()` returns the cached token and refreshes it once it is close to
// expiry, so calling it on every request costs nothing extra.
//
// `@/firebaseConfig` is imported lazily, as `image-upload.ts` does: importing
// it eagerly would run `getRemoteConfig(app)` in every test that builds a Tina
// http client, and jsdom does not support it.

/** The signed-in user's Firebase ID token, or `null` when nobody is signed in. */
export async function tinaIdToken(): Promise<string | null> {
  const { auth } = await import("@/firebaseConfig");
  await auth.authStateReady();
  const user = auth.currentUser;
  return user ? user.getIdToken() : null;
}

/** `Authorization` header for one Tina orchestrator request; empty when signed out. */
export async function tinaAuthHeaders(): Promise<Record<string, string>> {
  const token = await tinaIdToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
